<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入产品</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="'/supply/purchasePlan/download/import/template'"
          @uploadAfter="uploadAfter"
          :acceptType="[FileTypeEnum.XLSX, FileTypeEnum.XLS]"
          container-type="TRANSFER"
          style="margin-bottom: 10px;">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls/xlsx的文件',
            '同一个SKU存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, uploadMixin} from "@/minxins";
import {purchasePlanImportProduct} from "@/api/purchase";
import {FileTypeEnum} from "@/components/upload/enum"

export default {
  name: "app-import-product-modal",
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      FileTypeEnum,
    }
  },
  props: {
    hideSkuList: {
      required: false,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    uploadAfter(attId, data, uploadCb) {
      this.importHandleLoading = true;
      purchasePlanImportProduct(attId, {hideSkuList: this.hideSkuList})
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
    }
  }
}
</script>

<style scoped>

</style>
